import axios from 'axios';
import { ANALYTICS_API_BASE_URL } from '../config';

const buildDateParams = ({ dateFrom, dateTo }) => {
  const params = {};
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  return params;
};

export const getAnalyticsProjectOverview = async ({
  accessToken,
  projectId,
  dateFrom,
  dateTo,
}) => {
  const response = await axios.get(
    `${ANALYTICS_API_BASE_URL}/analytics/overview/projects/${projectId}`,
    {
      params: {
        accessToken,
        ...buildDateParams({ dateFrom, dateTo }),
      },
    }
  );
  return response.data;
};
